
export const productsList = [
    {
        name: "Discovery MI MIDR",
        avg_xray_gen_of_events: 1,
        avg_downtime_for_xray_gen: 67.7,
        avg_limited_use: 76.5,
        avg_labor_hours: 9.93,
        xray_tube_failure_avg_donwtime_in_h: 63.7,
        avg_labor: 5,
        perf: 0.87,
    },
    {
        name: "Omni Legend",
        avg_xray_gen_of_events: 1,
        avg_downtime_for_xray_gen: 67.7,
        avg_limited_use: 76.5,
        avg_labor_hours: 9.93,
        xray_tube_failure_avg_donwtime_in_h: 63.7,
        avg_labor: 5,
        perf: 0.87,
    },
    {
        name: "Starguide",
        avg_xray_gen_of_events: 1,
        avg_downtime_for_xray_gen: 67.7,
        avg_limited_use: 76.5,
        avg_labor_hours: 9.93,
        xray_tube_failure_avg_donwtime_in_h: 63.7,
        avg_labor: 5,
        perf: 0.87,
    },
] as const;